<template>
  <div id="case-index">
    <header-section :subnav_show="false" :change_color="true"></header-section>

    <!-- ======= Hero Section ======= -->
    <div id="hero-case" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="container" data-aos="fade-up">
      <!-- ======= Title Section ======= -->
      <div class="section-title">
        <h2>客户案例</h2>
        <p>CASES</p>
      </div>
      <!-- ======= Content Section ======= -->
      <el-row :gutter="15">
          <el-col :span="6">
            <div class="case-sidebar">
              <!-- <h3 class="sidebar-title">搜索</h3>
            <div class="sidebar-item search-form">
              <form action="">
                <input type="text">
                <button type="submit"><i class="bi bi-search"></i></button>
              </form>
            </div> -->
              <!-- End sidebar search form-->
              <h3 class="sidebar-title">分类</h3>
              <div class="sidebar-item categories">
                <ul>
                  <li @click="current_page=1;queryParam.channelId = 104;getArticlePageList()">
                    <a href="javascript:void(0)" :class="queryParam.channelId == 104 ? 'active-link' : ''">
                      全部类别
                    </a>
                  </li>
                  <li v-for="(v, i) in reSubChannelList" :key="i" @click="current_page=1;queryParam.channelId = v.id;getArticlePageList(v)">
                    <a href="javascript:void(0)" :class="queryParam.channelId == v.id ? 'active-link' : ''">
                      {{ v.channelName }}
                    </a>
                    <!-- <a :href="'/case?key=&cid='+v.id+'&page=1&pagesize=10'" class="cid==v.id?'active-link':''">{{v.channelName}}</a> -->
                  </li>
                </ul>
              </div>
              <!-- End sidebar categories-->
            </div>
            <!-- End sidebar -->
          </el-col>
          <!-- End case sidebar -->

          <el-col :span="18" class="entries">
            <div v-if="this.reDataList.length > 0">
              <div class="case" v-for="(bean, index) in reDataList" :key="index">
                <a :href="'/case/detail/' + bean.id" target="_blank">
					<el-row>
                      <el-col :span="8" class="pic">
						<img :src="bean.image" alt="">
                      </el-col>
                      <el-col :span="16" class="case-info">
						<h4><a :href="'/case/detail/' + bean.id" class="a-link" target="_blank">{{ bean.title }}</a></h4>
						<div class="" v-html="bean.summary"></div>
						<div class="more"><a :href="'/case/detail/' + bean.id" target="_blank">
							<i class="bi bi-arrow-right-short"></i>查看详情</a>
						</div>
                      </el-col>
					</el-row>
                </a>
              </div>
            </div>
            <!-- End case entry -->
            <div class="home_empty_list" v-else>
              <i class="font iconfont">&#xe600;</i>暂无相关数据！
            </div>
            <div class="pager_block" style="clear: both;" v-if="this.reDataList.length > 0">
              <el-pagination @current-change="current_change" background layout="total, prev, pager, next, jumper"
                :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
            </div>
          </el-col>
        </el-row>
    </div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
  components: {
    HeaderSection,
    FooterSection
  },
  props: {},
  data() {
    return {
      queryParam: {
        channelId: 104,
        isShow: 1,
        page: 1,
        limit: 10
      },
      currChannelId: 104,
      reSubChannelList: [],
      reDataList: [],
      current_page: 1,
      page_size: 10,
      total_pages: 0,
      total_data: 0,

    };
  },
  // watch: {
  //   '$route'() {
  //     this.queryParam.channelId = this.$route.params.id;
  //     this.getArticlePageList();
  //   }
  // },
  computed: {
  },
  methods: {

    getArticlePageList(v) {
      if(v){
        //添加标题和meta标签
        document.title =v.channelName + '-河北科瑞达仪器科技股份有限公司'
        let m = document.querySelectorAll('meta');
        const meta = document.createElement('meta')
        meta.name = 'keywords'
        meta.content = v.channelName
        
        m[0].after(meta)
        for(let i=0;i<m.length;i++){
          if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
            m[i].remove()
          }
        }
      }
      this.queryParam.page = this.current_page
      this.$get(this.$api.getArticlePageList, this.queryParam).then(response => {
        if (response.code === 0) {
          this.reDataList = response.data.list;

          this.page_size = response.data.pagesize;
          this.total_pages = response.data.totalpages;
          this.total_data = response.data.totalrecords;

          this.loading = false

        } else {
          window.console.log(response.msg);
        }
      });
    },
    getSubChannelList() {
      this.$get(this.$api.getSubChannelList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reSubChannelList = res.data;
          // this.page_size = response.data.pagesize;
          // this.total_pages = response.data.totalpages;
          // this.total_data = response.data.totalrecords;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    // 分页改变
    current_change: function (e) {
      this.current_page = e;
      this.getArticlePageList();
    },
  },
  created() {
    // if (typeof this.$route.params.id == "undefined") {
    //   this.queryParam.channelId = this.currChannelId;
    // }
    this.getSubChannelList();
    this.getArticlePageList();
    document.title='客户案例-河北科瑞达仪器科技股份有限公司'
			let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
			let m = document.querySelectorAll('meta');
			const meta = document.createElement('meta')
			meta.name = 'keywords'
			for(let i=0;i<m.length;i++){
				// if(m[i].content =='产品中心'){
				//     m[i].remove()
				// }
				arr.some(item => {
					if(item == m[i].content){
						m[i].remove()
					}
				})
			}
			meta.content = '客户案例'
			
			m[0].after(meta)
			for(let i=0;i<m.length;i++){
				if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
					m[i].remove()
				}
			}
  },
  mounted() {
  }
};
</script>
<style scoped>
/deep/ .more{
    float: right;
}
>>> .el-pagination__jump{
    margin-left: 10px;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-case {
  width: 100%;
  height: 45vh;
  background: url("~@/static/img/banner/customer-banner.jpg");
  background-size: cover;
  position: relative;
}
#case-index{
  overflow-x: hidden;
}
/*--------------------------------------------------------------
# cases
--------------------------------------------------------------*/
.case {
  position: relative;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 5px;
  background: #fff;
  transition: 0.2s;
  margin-bottom: 30px;
}

.case .el-row{
	margin-bottom: 0;
}
.case:hover {
  transform: translateY(-10px);
}

.case .pic {
  overflow: hidden;
  width: 300px;
  height: 156px;
}

.case .pic img {
  transition: ease-in-out 0.3s;
  width: 300px;
  height: 156px;
}

.case .case-info {
  padding-left: 30px;
}

.a-link {
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  font-size: 16px;
  font-weight: 700;
  color: rgb(4, 31, 121);
  margin-top: 4px;
}

.a-link:hover {
  color: rgb(247, 41, 5);
} 

.case h4 {
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 18px;
  color: #37517e;
}

.case span {
  display: block;
  font-size: 14px;
  padding-bottom: 10px;
  position: relative;
  font-weight: 500;
}

.case span::after {
  content: "";
  position: absolute;
  display: block;

}

.case p {
  margin: 10px 0 0 0;
  font-size: 14px;
}

/*--------------------------------------------------------------
# Cases List
--------------------------------------------------------------*/
.entry {
  padding: 30px;
  margin-bottom: 60px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.entries .h3 {
  font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", serif;
}

.case-sidebar {
  padding: 30px;
  margin: 0 0 60px 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  background: #fff;
}

.case-sidebar .sidebar-title {
  font-size: 20px;
  font-weight: 700;
  padding: 0 0 0 0;
  margin: 0 0 15px 0;
  color: #493c3e;
  position: relative;
}

.case-sidebar .sidebar-item {
  margin-bottom: 30px;
}

.case-sidebar .categories ul {
  list-style: none;
  padding: 0;
}

.case-sidebar .categories ul li+li {
  padding-top: 10px;
}

.case-sidebar .categories ul a:hover {
  color: red;
}

.case-sidebar .categories ul a span {
  padding-left: 5px;
  color: #aaaaaa;
  font-size: 14px;
}
.more a:hover{
	background: blue;
}
.more a{
	background: #2828f2;
	color:#fff
}
</style>